"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTitle = void 0;
const react_1 = __importStar(require("react"));
const icons_1 = require("../../../theme/icons");
const Dialog_1 = require("../../modals/dialogs/Dialog");
const __1 = require("..");
const EditableTitle_styles_1 = require("./EditableTitle.styles");
const EditableTitle = ({ name, editHandler, children, subTitle, icon: Icon, edited = false, openDialog, setOpenDialog, isBold, isEditable, isStyledContent, userIsEditing, tooltipMessage, controlElemId, }) => {
    const [currentName, setCurrentName] = (0, react_1.useState)(name);
    const [value, setValue] = (0, react_1.useState)(name);
    const [error, showError] = (0, react_1.useState)(false);
    const [isEditing, setIsEditing] = (0, react_1.useState)(edited);
    (0, react_1.useEffect)(() => {
        setValue(name);
    }, [name]);
    const onEditValue = (0, react_1.useCallback)((newValue, event) => {
        editHandler(false, newValue);
        setValue(newValue);
        setIsEditing(false);
        if (userIsEditing) {
            userIsEditing(false);
        }
        if (event)
            event.stopPropagation();
    }, [editHandler, userIsEditing]);
    const onEdit = (0, react_1.useMemo)(() => () => {
        setIsEditing(true);
        setCurrentName(value);
    }, [value]);
    const onChangeFn = (0, react_1.useMemo)(() => (val) => {
        showError(false);
        setValue(val);
    }, []);
    const onEscapeFn = (0, react_1.useMemo)(() => (e) => {
        setValue(currentName);
        editHandler(true);
        setIsEditing(false);
        e.stopPropagation();
    }, [currentName, editHandler]);
    const openDialogFn = () => {
        if (setOpenDialog) {
            setOpenDialog(true);
        }
    };
    (0, react_1.useEffect)(() => {
        if (userIsEditing) {
            userIsEditing(isEditing);
        }
    }, [isEditing, userIsEditing]);
    const onClickFn = (e) => {
        if (!isEditable) {
            return;
        }
        if (isStyledContent && isEditable) {
            e.preventDefault();
            onEdit();
            return;
        }
        else if (isEditable) {
            onEdit();
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(EditableTitle_styles_1.EditableTitleWrapper, null,
            Icon && (react_1.default.createElement(EditableTitle_styles_1.IconWrapper, null,
                react_1.default.createElement(Icon, null))),
            react_1.default.createElement(EditableTitle_styles_1.EditableTitleSubWrapper, null,
                react_1.default.createElement(EditableTitle_styles_1.ProjectLabelContainer, { "$isBold": isBold }, isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(__1.TextInputFieldCompact, { label: "", tooltip: tooltipMessage, autoFocus: true, disabled: false, placeholder: "", onChange: (value) => {
                            onChangeFn(value);
                        }, value: value, errorText: error ? "Error" : undefined, onBlur: (newValue) => {
                            if (newValue) {
                                onEditValue(newValue);
                            }
                        }, onEnter: (newValue) => {
                            if (newValue) {
                                onEditValue(newValue);
                            }
                        }, onEscape: (e) => {
                            onEscapeFn(e);
                        }, nameField: true }))) : (react_1.default.createElement(EditableTitle_styles_1.ProjectLabel, { htmlFor: controlElemId, "$isEditable": isEditable, onClick: onClickFn },
                    react_1.default.createElement(EditableTitle_styles_1.ProjectLabelText, { "$isEditable": isEditable }, isStyledContent ? children : value),
                    isEditable && (react_1.default.createElement(EditableTitle_styles_1.ProjectLabelEditBtn, null,
                        react_1.default.createElement(icons_1.Edit, { size: "small" })))))),
                subTitle && (react_1.default.createElement(EditableTitle_styles_1.Subtitle, null,
                    react_1.default.createElement(EditableTitle_styles_1.SubtitleLabel, { onClick: openDialogFn }, subTitle),
                    children && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(EditableTitle_styles_1.InfoWrapper, { onClick: openDialogFn },
                            react_1.default.createElement(icons_1.Info, null)),
                        react_1.default.createElement(Dialog_1.Dialog, { open: !!openDialog, setOpen: setOpenDialog }, children)))))))));
};
exports.EditableTitle = EditableTitle;
//# sourceMappingURL=EditableTitle.js.map